module.exports = __webpack_public_path__ + "img/employees.c7b77331.svg";